var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-3 px-1 d-flex flex-column vh-content" },
    [
      _c(
        "b-card",
        {
          staticClass: "board-column shadow mb-0 bg-lighten-5",
          attrs: { small: "", "no-body": "", "bg-variant": "primary" }
        },
        [
          _c(
            "b-card-body",
            {
              staticClass:
                "d-flex flex-row justify-content-between align-items-center py-0 pl-1 pr-2"
            },
            [
              _c(
                "b-card-title",
                {
                  staticClass:
                    "h5 ml-2 my-3 text-primary text-darken-4 text-capitalize"
                },
                [_vm._v(" " + _vm._s(_vm.column.name) + " ")]
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED067" } },
                [
                  _vm.column.canCreate && _vm.showActions
                    ? _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "ripple",
                              rawName: "v-ripple.400",
                              value: "rgba(113, 102, 240, 0.15)",
                              expression: "'rgba(113, 102, 240, 0.15)'",
                              modifiers: { "400": true }
                            }
                          ],
                          staticClass: "btn-icon",
                          attrs: {
                            variant: "primary",
                            size: "sm",
                            "data-cy": "create-activity"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("create-activity", _vm.column)
                            }
                          }
                        },
                        [_c("feather-icon", { attrs: { icon: "PlusIcon" } })],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }